import companyProfile from '../../widgets/general/company-profile'
import companyArticles from '../../widgets/general/company-articles'
import executivesInCompany from '../../widgets/general/executives-in-company'
import companyLatestPosts from '../../widgets/general/company-latest-posts'
import companyStats from '../../widgets/general/company-stats'
import companyFeaturedArticles from '@/query/widgets/general/company-featured-articles'
import companyArticleSection from '@/query/widgets/general/company-article-section'
import companyExecutiveList from '@/query/widgets/general/company-executive-list'
import companyPortalBannerWidget from '@/query/widgets/general/company-portal-banner'
import companyLeadershipWidget from '@/query/widgets/general/company-leadership'
import companyPartnershipsWidget from '@/query/widgets/general/company-partnerships'
import companyPartnershipsListWidget from '@/query/widgets/general/company-partnerships-list'
import companyForm from '@/query/widgets/general/company-form'
import companyGallery from '@/query/widgets/general/company-gallery'

const companyLayoutWidgets = () => [
  companyProfile(),
  companyArticles(),
  executivesInCompany(),
  companyLatestPosts(),
  companyStats(),
  companyFeaturedArticles(),
  companyArticleSection(),
  companyExecutiveList(),
  companyPortalBannerWidget(),
  companyLeadershipWidget(),
  companyPartnershipsListWidget(),
  companyPartnershipsWidget(),
  companyForm(),
  companyGallery()
]

export default companyLayoutWidgets
